import React, { useState } from "react";
import { Button } from "@heroui/button";
import { Wallet } from "lucide-react";
import { useAuth } from "@/hooks/useAuth";
import { UserSettingsModal } from "./user-settings-modal";

interface ConnectWalletButtonProps {
  variant?: "primary" | "secondary";
  size?: "sm" | "md" | "lg";
  className?: string;
  rounded?: boolean;
}

export const ConnectWalletButton: React.FC<ConnectWalletButtonProps> = ({
  variant = "primary",
  size = "md",
  className = "",
  rounded = false,
}) => {
  const { isAuthenticated, isLoading, user, login } = useAuth();
  const [showSettings, setShowSettings] = useState(false);

  const handleClick = () => {
    if (isAuthenticated) {
      setShowSettings(true);
    } else {
      login();
    }
  };

  // Get display name from user
  const getDisplayName = () => {
    if (user?.email?.address) {
      const email = user.email.address;
      // Truncate email if longer than 20 characters
      if (email.length > 20) {
        return email.slice(0, 17) + "...";
      }
      return email;
    }

    if (user?.wallet?.address) {
      return user.wallet.address.slice(0, 6) + "...";
    }

    return "User";
  };

  const displayName = getDisplayName();

  return (
    <>
      <Button
        onPress={handleClick}
        size={size}
        isLoading={isLoading}
        className={`
          ${
            variant === "primary"
              ? "bg-swapper-primary hover:bg-swapper-primary/90 text-white"
              : "bg-swapper-secondary hover:bg-swapper-secondary/90 text-white"
          }
          font-semibold transition-all duration-200 ease-out
          ${rounded ? "rounded-full" : "rounded-xl"}
          ${className}
        `}
        startContent={!isLoading && <Wallet className="w-4 h-4" />}
      >
        {isAuthenticated ? displayName : "Connect Wallet"}
      </Button>

      <UserSettingsModal
        isOpen={showSettings}
        onClose={() => setShowSettings(false)}
      />
    </>
  );
};